import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSettings } from '../services/api';

const HeroSection = () => {
  const [settings, setSettings] = useState({ heroImage: '/assets/images/hero_overlay.png' });

  useEffect(() => {
    getSettings()
      .then(data => {
        if (data && data.heroImage) {
          setSettings(data);
        }
      })
      .catch(() => {
        // Fallback to default if API fails
      });
  }, []);

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: '#0a0a0a' }}
    >
      {/* Hero background image */}
      <div className="absolute inset-0">
        <img
          src={settings.heroImage}
          alt="Seltz Hero"
          className="w-full h-full object-cover opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-32 flex flex-col items-center justify-center text-center w-full min-h-[80vh]">
        <div className="max-w-4xl">
          <h1
            className="text-white font-black italic leading-[0.9] mb-6 drop-shadow-[0_10px_10px_rgba(0,0,0,0.5)]"
            style={{
              fontFamily: 'Nunito, sans-serif',
              fontSize: 'clamp(4rem, 12vw, 10rem)',
              textShadow: '0 10px 30px rgba(0,0,0,0.8)',
            }}
          >
            premium
            <br />
            vodka soda
          </h1>
          <p
            className="text-white text-lg sm:text-xl md:text-2xl mb-12 max-w-xl mx-auto font-bold tracking-wide drop-shadow-md"
            style={{
              fontFamily: 'Nunito, sans-serif',
              textShadow: '0 2px 10px rgba(0,0,0,0.5)',
            }}
          >
            ideală pentru orice plan
          </p>
          <div className="flex flex-wrap gap-6 justify-center">
            <Link
              to="/shop"
              data-testid="hero-shop-btn"
              className="bg-white text-black font-black italic text-base sm:text-lg px-12 py-4 rounded-full hover:bg-gray-100 transition-all duration-300 hover:scale-110 shadow-2xl"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              cumpără acum
            </Link>
            <Link
              to="/about"
              data-testid="hero-learn-btn"
              className="border-2 border-white text-white font-black italic text-base sm:text-lg px-12 py-4 rounded-full hover:bg-white/20 transition-all duration-300 hover:scale-105 backdrop-blur-sm"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              află mai multe
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
